export default __webpack_public_path__ + "static/media/Adjunta_credencial_frente.61930570.gif";